import * as React from 'react';
import SuperCritical from 'lib/supercritical';
import { TZUtils } from 'lib/tzutils';

import { BerthManagerDashboard, Tab } from './model';
import { OperationsForecastView } from './operationsforecastview';
import { ActivityFeedView } from './activityfeedview';
import { ServicesDashboardView } from './servicesdashboardview';

export let BerthManagerDashboardView = SuperCritical(({model, model: { CurrentTab }, tzutils } : { model : BerthManagerDashboard, tzutils : TZUtils }) =>
    <div className="berthmanager-dashboard">
        <header>
            <div className="pc-page-title">Berth Managers Dashboard</div>
            <ul className="tabs">
                <li className={CurrentTab() === Tab.Activity ? 'selected' : ''} onClick={() => CurrentTab(Tab.Activity)}>Activity</li>
                <li className={CurrentTab() === Tab.Services ? 'selected' : ''} onClick={() => CurrentTab(Tab.Services)}>Services</li>
            </ul>
        </header>
        {CurrentTab() === Tab.Activity ? <ActivityView model={model} /> :
         CurrentTab() === Tab.Services ? <ServicesView model={model} tzutils={tzutils} /> :
         null}
    </div>),
    ActivityView = SuperCritical(({ model } : { model : BerthManagerDashboard }) =>
        <section className="activity">
            <ActivityFeedView model={model.ActivityFeed} />
            <OperationsForecastView model={model.OperationsForecast} />
        </section>),
    ServicesView = SuperCritical(({ model, tzutils } : { model : BerthManagerDashboard, tzutils : TZUtils }) =>
        <section className="services">
            <ServicesDashboardView model={model.ServicesDashboard} tzutils={tzutils} />
        </section>)


// WEBPACK FOOTER //
// ./apps/portcall/berthmgrdashboard/view.tsx